import logo from "../assets/goat-01-01.png"
function Logo ()
{
    return (
        <div>
            <img  className=" mt-[-1rem] ml-[-2rem] z-50 w-[12rem] h-[12rem] " src={logo} alt="logo"/>
        </div>
    )
}

export default Logo
